import { render, staticRenderFns } from "./Project8Zh.vue?vue&type=template&id=31901298&scoped=true&"
import script from "./Project8Zh.vue?vue&type=script&lang=js&"
export * from "./Project8Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project8Zh.vue?vue&type=style&index=0&id=31901298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31901298",
  null
  
)

export default component.exports